import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Menu from "./pages/Menu";
import Gallery from "./pages/Gallery";
import HowItWorks from "./pages/HowItWorks";
import Testimonials from "./pages/Testimonials";
import Reviews from "./pages/Reviews";
import NextEvent from "./pages/NextEvent";
import Reserve from "./pages/Reserve";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/next-event" element={<NextEvent />} />
          <Route path="/reserve" element={<Reserve />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
